import {PayloadAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

type IUserInfo = {
  mid: number
  name: string
  avatar: string
}
export type IListItem = {
  rank: string
  score: number
  score_display: number
  man_user_info: IUserInfo
  girl_user_info: IUserInfo
}

export const love_list = createAsyncThunk(
  '/live/hg_family/love_rank',
  async (arg: {family_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<{list: IListItem[]}>>(
      '/live/hg_family/love_rank',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

export const LoveListSlice = createSlice({
  name: 'LoveList',
  initialState: {
    love_list: [] as IListItem[],
    curPage: 'rank',
  },
  reducers: {
    setCurPage(state, action: PayloadAction<string>) {
      // state.curPage = action.payload
      Object.assign(state, {...{curPage: action.payload}})
    },
  },
  extraReducers: (builder) => {
    builder.addCase(love_list.fulfilled, (state, action) => {
      // state.love_list = action.payload.love_list
      Object.assign(state, {love_list: action.payload.list})
    })
  },
})

export default LoveListSlice.reducer
export const LoveListActions = LoveListSlice.actions

export const useLoveListState = () => {
  const data = useSelector((state) => {
    return state.LoveList
  })
  return data
}
